#@import Booking.Presenters.Base
#@export Booking.Presenters.Phone

class Booking.Presenters.Phone extends Booking.Presenters.Base

  toHash: ->
      customerPhone: @model.getPhoneNumber()
      maxLength: @options.customerPhoneMaxLength
      bhc: 'input:phone'
      bhcPhone: 'icon:DeletePhoneNumber'
